export default __webpack_public_path__ + "static/media/chevron_right_blue.77845411.svg";